import axios from 'axios';

import { buildApiV2Url } from './utils/apiUtils';
import { generateApiError } from './utils/apiErrorMessages';
import changeRedirectUrlSubmissionError from './submissionErrors/changeRedirectUrlSubmissionError';

const setThankYouVisibility = (
  collectionPath,
  entityId,
  { isEnabled, redirectUrl = null },
) =>
  axios
    .patch(buildApiV2Url(`${collectionPath}/${entityId}`), {
      end_enabled: isEnabled,
      redirect_url: redirectUrl,
    })
    .catch(
      generateApiError({
        submissionErrorMap: changeRedirectUrlSubmissionError,
      }),
    );

export default setThankYouVisibility;
